import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Restitution Coordinates List with Query
export const getRestitutionCoordinatesListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_RESTITUTION_COORDINATES_LIST}?${stringifyParams(
			params
		)}`
	);
};

// Get Restitution Coordinates List
export const getRestitutionCoordinatesList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['createdAt:desc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_RESTITUTION_COORDINATES_LIST}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Restitution Coordinates
export const getRestitutionCoordinatesItem = (restitution_coordinates_id, populate = []) => {
	const populateParam = populate.length > 0 ? `?${stringifyParams({ populate })}` : '';
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_RESTITUTION_COORDINATES}${restitution_coordinates_id}${populateParam}`
	);
};

// Add New Restitution Coordinates
export const addNewRestitutionCoordinatesApi = restitution_coordinates => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_RESTITUTION_COORDINATES}`,
		restitution_coordinates
	);
};

// Update Restitution Coordinates
export const updateRestitutionCoordinatesApi = restitution_coordinates => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_RESTITUTION_COORDINATES}${restitution_coordinates._id}`,
		restitution_coordinates
	);
};

// Delete Restitution Coordinates
export const deleteRestitutionCoordinatesApi = restitution_coordinates_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_RESTITUTION_COORDINATES}${restitution_coordinates_id}`
	);
};
